import { i18n } from '../../i18n';
import { TAG_TYPE } from '@/constants';
import _ from 'lodash';

export const ROLE_KINDS = [
  'super',
  'application',
  'custom',
]


export const filterColumnsHash = {
  name_cont: {
    label: i18n.t('role.name'),
    renderCell: {
      component: 'input'
    }
  },
  kind_eq: {
    label: i18n.t('role.kind'),
    renderCell: {
      component: 'select',
      props: {
        clearable: true,
        options: _.map(ROLE_KINDS, (value) => ({ label: i18n.t(`role.kinds.${value}`), value: value }))
      }
    }
  },
}

export const columnsHash = {
  id: {
    label: i18n.t('role.id'),
    width: 80,
  },
  name: {
    label: i18n.t('role.name'),
  },
  kind: {
    label: i18n.t('role.kind'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.kind) {
        return <span>/</span>
      }
      return <el-tag type={TAG_TYPE[row.kind]}>{i18n.t(`role.kinds.${row.kind}`)}</el-tag>;
    },
  },
  created_at: {
    label: i18n.t('role.createdAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  updated_at: {
    label: i18n.t('role.updatedAt'),
    minWidth: 120,
    renderCell: 'time',
  },
}

export const formColumnsHash = {
  name: {
    label: i18n.t('role.name'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
}
